import styled from "styled-components";
import { theme } from '../../theme'

export const OverviewCardWrapper = styled.div`
    background-color: ${theme.colors.mainWhite};
    box-shadow: 0px 2px 4px rgba(0, 0, 0, 0.0293252);
    border-radius: 1.1rem;
`

export const OverviewCardTop = styled.div`
    padding: 2rem 1.5rem;
    display: flex;
    align-items: center;
    justify-content: space-between;

    span {
        font-weight: 700;
        font-size: 2rem;
        color: #3B3B42;
        text-transform: capitalize;

        @media only screen and (max-width: 340px) {
            font-size: 1.8rem;
         }
    }
`
export const SelectContainer = styled.div`
    height: 25px;
    width: 7.2rem;
    min-width: 13ch;
    max-width: 13ch;
    border: 1px solid var(--select-border);
    color: #565B73;
    border-radius: 0.25rem;
    padding: 0 0.9rem;
    font-size: 1.25rem;
    cursor: pointer;
    background-color: #fff;
    background-image: linear-gradient(to top,#f9f9f9,#fff 33%);
    border: 1px solid  #DFE1E4;
    display: grid;
    grid-template-areas: "select";
    align-items: center;

    &::after {
        content: "";
        width: 0.8em;
        height: 0.5em;
        background-color: ${theme.colors.grey03};
        clip-path: polygon(100% 0%, 0 0%, 50% 100%);
        grid-area: select;
        justify-self: end;
      }

    select {
        // A reset of styles, including removing the default dropdown arrow
        appearance: none;
        // Additional resets for further consistency
        background-color: transparent;
        border: none;
        padding: 0 1em 0 0;
        margin: 0;
        width: 100%;
        font-family: inherit;
        font-size: inherit;
        cursor: inherit;
        line-height: inherit;
        outline: none;
        grid-area: select;

        &::-ms-expand {
            display: none;
        }
    }
`

export const Hr = styled.hr`
    height: 1px;
    background-color:rgb(216 216 216 / 37%);
    flex: 1;
    border: none;
`